import React from 'react';
import { InputNumber } from "antd";
import "./currencyInput.css";
import { SeparateNumberFormat } from '../../../services/utils';
import i18n from 'i18next';

const CustomInputCurrency = ({ currency, value, onChange, disabled, step, style }) => {

  const handleInputChange = (newValue) => {
    if (newValue === null) return;
    onChange(newValue);
  };

 const formatStep = (stepValue) => {
    if (stepValue === undefined || stepValue === null) {
      return 1;
    }
    const stepString = String(stepValue).replace(',', '.');
    const parsedStep = parseFloat(stepString);
    if (isNaN(parsedStep)) {
      return 1;
    }
    return parseFloat(parsedStep.toFixed(2));
  };

  const parseValue = (value) => {
    if (!value) return '';

    const isSpanish = i18n.language.substring(0, 2) === 'es';
    let replacedValue;

    if (isSpanish) {
      replacedValue = String(value)
        .replace(/\./g, '')
        .replace(',', '.');
    } else {
      replacedValue = String(value).replace(/,/g, '');
    }

    const parsed = parseFloat(replacedValue);
    if (isNaN(parsed)) {
      return 0;
    }
    return parsed.toFixed(2);
  };

  return (
    <div className="currency-input-container" style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
      <span className="currency-symbol">${currency}</span>
      <InputNumber
        type="text"
        formatter={SeparateNumberFormat}
        parser={parseValue}
        disabled={disabled}
        className="inputGroup"
        min={0}
        value={value || 0}
        onChange={handleInputChange}
        // step={formatStep(step)}
        style={style}
        precision={2}
      />
    </div>
  );
};

export default CustomInputCurrency;

